module.exports = __webpack_public_path__ + "files/dac7eff9ce48b0049db272722d39d988.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/places-2.png
// module id = 1470
// module chunks = 60